import BaseClient from '@/app/model/api/response/baseApiClient'

class MypageGetKeyApi extends BaseClient {
  public getKeyData () {
    const path = '/v1/company/apikey'

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'GET')
  }
}

export default new MypageGetKeyApi()
